import React from 'react';
import classnames from 'classnames';
import Spinner from 'react-spinkit';
import { textCenter } from 'scy/utils.mod.scss';

export default function BouncySpinner({ className }) {
  return (
    <div className={classnames(textCenter, className)}>
      <Spinner spinnerName="three-bounce" />
    </div>
  );
}
